import React, { useState } from 'react';
import { useNavigation } from 'context/NavigationContext';
import {
    BringzzPageContainer,
    BringzzButton, BringzzIcon, BringzzText, BringzzInput
} from "@bringzz/components";
import useUser from 'hooks/useUser';
import useRequest from 'hooks/useRequest';
import { useAuth } from 'context/AuthContext';
import { useTranslation } from 'react-i18next';

let state = {
    checked: (
        <BringzzIcon
            icon="IconCheck"
            library="Custom"
            className="h-5 w-5 p-1 bg-magic-lilac text-light rounded-full"
            size="12"
        />
    ),
    unChecked: (
        <div></div>
    ),
};

const EditBioView = () => {
    const { backPress, navigate } = useNavigation();
    const { sendRequest, loading } = useRequest();
    const [inputValue, setInputValue] = useState('');
    const { user, refreshUserData } = useAuth();
    const { t } = useTranslation();

    return (
        <BringzzPageContainer
            header={{
                left: <BringzzIcon
                    size="22"
                    icon="IconChevronLeft"
                    folder="LineIcons"
                    className="cursor-pointer"
                    onClick={backPress}
                />,
                title: <BringzzText tag='h2'>{t('component.account.bio.title')}</BringzzText>,
            }}
            footer={
                <div className='pb-28 px-6'>
                    <BringzzButton
                        size='lg'
                        className='bg-magic-lilac w-full flex justify-center text-midnight-blue'
                        onClick={async () => {
                            await sendRequest({
                                method: 'POST',
                                url: `/module/profile/changeBio`,
                                data: { bio: inputValue }
                            }).then((response) => {
                                if (response.status === 'success') {
                                    refreshUserData()
                                    backPress()
                                }
                            }).catch((error) => {
                                console.log(error);
                            })
                        }}
                        disabled={!inputValue || loading}
                    >
                        {t('common.save')}
                    </BringzzButton>
                </div>
            }
        >
            <div className='p-6 space-y-4'>
                <BringzzInput onChange={(e, isValid, newValue) => {
                    setInputValue(newValue);
                }} id='bio' type='textarea' label={t('component.account.bio.label')} containerClassname="w-full" placeholder={t('component.account.bio.placeholder')} defaultValue={user.description} />
            </div>
        </BringzzPageContainer>
    );
}

export default EditBioView;
